import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@ontruck/orc';

const StopHandlingCell = ({ showIcon }) => {
  return showIcon && <Icon glyph="manipulation" size="1.6rem" color="grey500" />;
};

StopHandlingCell.propTypes = {
  showIcon: PropTypes.bool.isRequired,
};

export default StopHandlingCell;
